const colors = {
  white: '#fff',
  black: '#000',

  almostBlack: '#2c2e2f',
  battleship: '#484949',
  boulder: '#7a7979',
  silverSandAlt: '#a0a0a0',
  silverSand: '#bfc3c3',
  whiteSmoke: '#eaeaea',
  fog: '#f0f0f0',

  trafficCone: '#f60',
  taosSky: '#09c',
  bluebee: '#4dc2be',
  kermit: '#6bb220',
  lemonade: '#fc0',
  tutu: '#f13c68',
  recordRed: '#f00',

  boxShadow: 'rgba(0, 0, 0, 0.16)',

  taosSkyTint: '#66c2e0',
  trafficConeTint: '#ffa366',

  orange: '#ECA400',
  lightyellow: '#EAF8BF',
  seablue: '#006992',
  koamaru: '#27476E',
  oxford: '#001D4A',
};

export default colors;
